import { useContext } from 'react'
import { useSearchParams } from 'react-router-dom'

import { TrackingPageLayout as ReveniTrackingPageLayout } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import useIframeResize from '@/hooks/useIframeResize/useIframeResize'

const TrackingPageLayout = () => {
  const { context } = useContext(AppContext)
  const [searchParams] = useSearchParams()

  const merchantInfo = context.merchantInfo
  const hideHeader = searchParams.get('hide_header') === 'true'
  const isEmbedded = searchParams.get('embedded') === 'true'

  useIframeResize(isEmbedded)

  return (
    <ReveniTrackingPageLayout
      logoUrl={merchantInfo.theme?.logo_url}
      storeName={merchantInfo.name}
      hideHeader={hideHeader}
      embedded={isEmbedded}
    />
  )
}

export default TrackingPageLayout
